export default "__VITE_ASSET__81ScIiSk__"